(() => {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initReveal(root = document) {
    const items = [...root.querySelectorAll('[data-ela-reveal]')];
    if (!items.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach((item) => item.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });

    items.forEach((item) => observer.observe(item));
  }

  function initGallery(root = document) {
    const mainImage = root.querySelector('[data-ela-main-image]');
    const thumbs = [...root.querySelectorAll('[data-ela-thumb]')];
    if (!mainImage || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const nextSrc = thumb.dataset.src;
        const nextAlt = thumb.dataset.alt || '';
        if (!nextSrc || mainImage.src === nextSrc) return;

        mainImage.style.opacity = '.25';
        window.setTimeout(() => {
          mainImage.src = nextSrc;
          mainImage.alt = nextAlt;
          mainImage.style.opacity = '1';
        }, 130);

        thumbs.forEach((item) => item.classList.remove('is-active'));
        thumb.classList.add('is-active');
      });
    });
  }

  function initMobileBuy(root = document) {
    const mobileButton = root.querySelector('[data-ela-mobile-buy]');
    const primaryButton = root.querySelector('[data-ela-primary-buy]');
    const mobileBar = root.querySelector('.ela-mobile-buy');
    if (!mobileButton || !primaryButton || !mobileBar) return;
    mobileButton.addEventListener('click', () => primaryButton.click());

    const update = () => {
      mobileBar.classList.toggle('is-visible', primaryButton.getBoundingClientRect().bottom < 0);
    };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function initHeader() {
    const update = () => document.body.classList.toggle('ela-header-scrolled', window.scrollY > 20);
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function init(root = document) {
    if (!root.querySelector('.ela-page')) return;
    document.documentElement.classList.add('ela-js');
    initReveal(root);
    initGallery(root);
    initMobileBuy(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      initHeader();
    }, { once: true });
  } else {
    init();
    initHeader();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

